import React, { Fragment, useEffect, useState } from 'react'
import './inDashboard.css'
import {
   DummyImage,
   FollowersIcon,
   InPostImage,
   InPostsIcon,
   InReels1,
   InReelsIcon,
   PalyListIcon,
   UserImage,
   ViewsIcon
} from 'assets'
import InPostsCard from './InPostsCard'
import { useDispatch, useSelector } from 'react-redux'
import { formatNumber } from 'utils/formatNumber'
import { instagramPostType } from 'constant/const'
import {
   getDashboardAction,
   getPostListAction,
   resetFetchAllPostStatus
} from 'store/action/instagramDashboard'
import { Loader } from 'components'
import dayjs from 'dayjs'
import { createImageUrl } from 'utils/createImageUrl'
import SentimentScore from './components/SentimentScore'
import EmotionsScore from './components/EmotionsScore'
import SentimentChart from './components/SentimentChart'
import TopPostsSection from './components/VideoSection'

export const PostsReelsConst = [
   {
      id: 1,
      type: 'post',
      image: InPostImage,
      like: 45488,
      comment: 100155,
      view: 0,
      comments: [
         {
            id: 1,
            username: 'artlover92',
            text: 'This is amazing 🔥',
            likes: 12,
            time: '2025-04-26T10:00:00Z'
         },
         {
            id: 2,
            username: 'travelbug',
            text: 'Where is this place? 😍',
            likes: 5,
            time: '2025-04-26T08:30:00Z'
         },
         {
            id: 3,
            username: 'sunny_days',
            text: 'Love the vibe!',
            likes: 8,
            time: '2025-04-26T07:45:00Z'
         }
      ]
   },
   {
      id: 2,
      type: 'reel',
      image: InReels1,
      like: 80,
      comment: 15,
      view: 120,
      comments: [
         {
            id: 4,
            username: 'dancequeen',
            text: 'Such smooth moves 🔥🔥',
            likes: 20,
            time: '2025-04-26T11:15:00Z'
         },
         {
            id: 5,
            username: 'vidfan',
            text: 'Replayed it 5 times 😂',
            likes: 15,
            time: '2025-04-26T09:00:00Z'
         },
         {
            id: 6,
            username: 'editorlife',
            text: 'Editing on point!',
            likes: 10,
            time: '2025-04-26T06:00:00Z'
         }
      ]
   },
   {
      id: 3,
      type: 'post',
      image: InPostImage,
      like: 60,
      comment: 25,
      view: 0,
      comments: [
         {
            id: 7,
            username: 'naturegram',
            text: 'Nature is healing 🌿',
            likes: 18,
            time: '2025-04-25T16:00:00Z'
         },
         {
            id: 8,
            username: 'photoguy',
            text: 'Frame is perfect 📸',
            likes: 9,
            time: '2025-04-25T15:30:00Z'
         }
      ]
   },
   {
      id: 4,
      type: 'reel',
      image: InReels1,
      like: 150,
      comment: 40,
      view: 300,
      comments: [
         {
            id: 9,
            username: 'trendwatcher',
            text: 'This should trend 😍',
            likes: 30,
            time: '2025-04-26T10:30:00Z'
         },
         {
            id: 10,
            username: 'vibewithme',
            text: 'Feeling this vibe!',
            likes: 22,
            time: '2025-04-26T07:20:00Z'
         }
      ]
   },
   {
      id: 5,
      type: 'post',
      image: InPostImage,
      like: 20,
      comment: 5,
      view: 0,
      comments: [
         {
            id: 11,
            username: 'minimalist',
            text: 'Simple and beautiful ✨',
            likes: 5,
            time: '2025-04-26T09:15:00Z'
         }
      ]
   },
   {
      id: 6,
      type: 'reel',
      image: InReels1,
      like: 90,
      comment: 30,
      view: 210,
      comments: [
         {
            id: 12,
            username: 'reelcraze',
            text: 'Smooth transitions 🔥',
            likes: 16,
            time: '2025-04-26T08:45:00Z'
         },
         {
            id: 13,
            username: 'loopaddict',
            text: 'Watched it 10x!',
            likes: 14,
            time: '2025-04-26T05:30:00Z'
         }
      ]
   },
   {
      id: 7,
      type: 'post',
      image: InPostImage,
      like: 75,
      comment: 18,
      view: 0,
      comments: [
         {
            id: 14,
            username: 'dailyart',
            text: 'Saving this one ❤️',
            likes: 10,
            time: '2025-04-25T12:00:00Z'
         }
      ]
   },
   {
      id: 8,
      type: 'reel',
      image: InReels1,
      like: 110,
      comment: 35,
      view: 280,
      comments: [
         {
            id: 15,
            username: 'fypstar',
            text: 'This deserves more views 😍',
            likes: 28,
            time: '2025-04-26T06:30:00Z'
         }
      ]
   },
   {
      id: 9,
      type: 'post',
      image: InPostImage,
      like: 40,
      comment: 12,
      view: 0,
      comments: [
         {
            id: 16,
            username: 'moodygrams',
            text: 'Mood 💯',
            likes: 7,
            time: '2025-04-26T07:50:00Z'
         }
      ]
   },
   {
      id: 10,
      type: 'reel',
      image: InReels1,
      like: 130,
      comment: 22,
      view: 250,
      comments: [
         {
            id: 17,
            username: 'viralhub',
            text: 'This will blow up soon 🔥',
            likes: 25,
            time: '2025-04-26T11:00:00Z'
         }
      ]
   }
]

function InDashboard() {
   const [postsReelsTab, setPostsReelsTab] = useState('posts')
   const authData = useSelector((state) => state.user)
   const { userData } = authData

   const instagramDashboardData = useSelector((state) => state.instagramDashboard)
   const { inDashboardData, loading, getTopPostLoader, instagramChartDataLoader } =
      instagramDashboardData

   const dispatch = useDispatch()

   useEffect(() => {
      dispatch(getDashboardAction())
      return () => {}
   }, [])

   return (
      <div className="in-dashboard">
         {(loading || getTopPostLoader || instagramChartDataLoader) && <Loader />}
         <div className="dashboard-layouts">
            <div className="card pb-0">
               <div className="channel-section">
                  <div className="channel-details-wrap">
                     <div className="channel-image">
                        <img
                           src={
                              userData?.profile_picture_url
                                 ? createImageUrl(userData?.profile_picture_url)
                                 : DummyImage
                           }
                           alt="channel-image"
                        />
                     </div>
                     <div className="channel-desc">
                        <div className="channel-name-section">
                           <div className=" ch-name-wrap">
                              <h3 className="at-text-dark">{inDashboardData?.user?.username}</h3>
                              {/* <p
                                 className="at-text-light"
                                 style={{ fontSize: '12px', color: '#FF423D' }}>
                                 {channelDetails?.creation_date
                                    ? dayjs(channelDetails?.creation_date).format('D MMMM, YYYY')
                                    : ''}
                              </p> */}
                           </div>
                        </div>
                        <p
                           className="mt-2 at-text-light"
                           style={{ fontWeight: '400', whiteSpace: 'pre-wrap' }}>
                           {userData?.bio}
                           {/* 🎁 We make gifts for your loved ones <br /> 💌 DM for Orders <br /> 🛍️
                           Hampers, Resin Art, Customized gifts and many more !! */}
                        </p>
                        <div className="channel-counter mt-3 mb-3">
                           <div className="row">
                              <div className="col-12 col-sm-4 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <FollowersIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {formatNumber(userData?.followers_count || 0, 2)}
                                          </p>
                                          <span className="at-text-light text-uppercase">
                                             followers
                                          </span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-4 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <ViewsIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {' '}
                                             {formatNumber(userData?.follows_count || 0, 2)}
                                          </p>
                                          <span className="at-text-light text-uppercase">
                                             following
                                          </span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-sm-4 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <PalyListIcon className="paly-list-icon" />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {formatNumber(userData?.media_count || 0, 2)}
                                          </p>
                                          <span className="at-text-light text-uppercase">
                                             Total Posts
                                          </span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div className="row mt-3">
               <div className="col-12 col-lg-6 col-xl-4">
                  <SentimentScore />
               </div>
               <div className="col-12 col-lg-6 col-xl-8">
                  <EmotionsScore />
               </div>
            </div>
            <div className="sentiment-chart mt-4">
               <SentimentChart />
            </div>
            <div className="video-section mt-3">
               <TopPostsSection />
            </div>
         </div>
      </div>
   )
}

export default InDashboard
